import { pwnedPassword } from 'hibp'

export const REQUIRED = {
  message: 'This field is required',
  required: true
}

export const PASSWORD_STRENGTH = {
  message: 'Password needs to be at least 8 charactors',
  min: 8,
  validateTrigger: ['onChange', 'onBlur']
}

export const PASSWORD_LENGTH = {
  validateTrigger: 'onBlur',
  validator: async (_, value) => {
    if (!value) {
      return Promise.resolve()
    }

    const pwned = await pwnedPassword(value)
    return pwned
      ? Promise.reject(new Error('This has appeard in a list of known compromised passwords. Please try another'))
      : Promise.resolve()
  }
}

export const maxCharLength = (count) => ({
  max: count,
  message: `The text entered exceeds the maximum length of ${count} characters`
})

export const UUID_VALIDITY = {
  message: 'Please enter a valid UUID',
  pattern: /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/
}
